import { SelectData } from './select-input.model';

export interface ReceivableLayout {
  id?: number;
  layout: number;
  tipoRecebivel: number;
  codigoOcorrencia: string;
}

export interface ReceivableLayoutForm {
  id?: number;
  layout: SelectData;
  tipoRecebivel: SelectData;
  codigoOcorrencia: string;
}

export interface LayoutFilter {
  layout: SelectData;
  idTipoRecebivel: SelectData;
  ocorrencia: string;
}

export interface LayoutRequest {
  id?: number,
  layout: number,
  idTipoRecebivel: number, 
  nmRecebivel: string,
  ocorrencia: string
}
